import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Starter Website',
  price: '$500',
  suffix: '/starting',
  desc: 'Perfect for small businesses needing a professional online presence quickly.',
  features: ['Custom Design (No Templates)', 'Mobile Responsive', 'Basic SEO Setup', 'Contact Form Integration', '3 Round of Revisions'],
  highlighted: false
}, {
  name: 'Hosting',
  price: '$100',
  suffix: '/year',
  desc: 'The hosting fee covers the services and infrastructure required to keep it live, secure, and accessible on the internet.',
  features: ['Includes 5 Edits per Year', 'Premium Cloud Hosting', 'SSL Security Certificate', 'Daily Backups', 'Always Online & Accessible'],
  highlighted: true
}];
export function Pricing() {
  return <section id="pricing" className="py-24 bg-[#0A0A0F] relative" data-id="element-290">
      <div className="container mx-auto px-6 md:px-12" data-id="element-291">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-292">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-293">
            Simple, <span className="text-gradient" data-id="element-294">Upfront Pricing</span>
          </h2>
          <p className="text-lg mb-4 text-[#FFFFFF]" data-id="element-295">
            High-quality web design shouldn't be a mystery. Choose the package
            that fits your goals.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto items-stretch" data-id="element-296">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative rounded-3xl p-8 flex flex-col ${tier.highlighted ? 'bg-[#161622] border-2 border-blue-500 shadow-[0_0_30px_rgba(59,130,246,0.15)]' : 'bg-[#111118] border border-white/5'}`} data-id="element-297">
              <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-298">
                {tier.name}
              </h3>
              <p className="text-sm mb-6 text-[#FFFFFF]" data-id="element-299">{tier.desc}</p>

              <div className="mb-8" data-id="element-300">
                <span className="text-4xl font-bold text-white" data-id="element-301">
                  {tier.price}
                </span>
                <span className="text-[#FFFFFF]" data-id="element-302">{tier.suffix}</span>
              </div>

              <a href="#contact" className={`block w-full py-3 px-6 rounded-lg text-center font-medium transition-all mb-8 ${tier.highlighted ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]' : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'}`} data-id="element-303">
                Get Started
              </a>

              <div className="space-y-4 mt-auto" data-id="element-304">
                {tier.features.map((feature, fIndex) => <div key={fIndex} className="flex items-start gap-3" data-id="element-305">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500/10 flex items-center justify-center mt-0.5" data-id="element-306">
                      <Check size={12} className="text-blue-400" data-id="element-307" />
                    </div>
                    <span className="text-sm text-[#FFFFFF]" data-id="element-308">{feature}</span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}